import { CopyItem } from '@/components/valuePropList';

import messages from './messages';

export const paymentValueProps: Array<CopyItem> = [
	{
		id: 'valueProp1',
		header: messages.valueProp1Head,
		body: messages.valueProp1Body,
	},
	{
		id: 'valueProp2',
		header: messages.valueProp2Head,
		body: messages.valueProp2Body,
	},
	{
		id: 'valueProp3',
		header: messages.valueProp3Head,
		body: messages.valueProp3Body,
	},
];
